// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#enabled_programme_video_box{height:calc(100% - 12rem)}@media screen and (max-width:767px){#enabled_programme_video_box{height:calc(100% - 12rem)}}@media screen and (max-width:576px){#enabled_programme_video_box{height:calc(100% - 14rem)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
